// extracted by mini-css-extract-plugin
module.exports = {"container":"translation_container__27_X8","item":"translation_item__2CHaq","language":"translation_language__1z7sG","row":"translation_row__3ch0Q"};